<template>
  <div class="container mt-5 text-body-1" style="height: 87%">
    <div class="text-center">
      <h5 style="text-transform: capitalize;" class="text-h5">
        Bienvenue {{ user.user_info.gender | pronom }} {{ user.user_info.given_name }} {{ user.user_info.family_name }} !
      </h5>
      <div>
        <div class="form-group">
          <label class="label">Veuillez insérer votre Identifant Permanent Patient (IPP) :</label> <br>
          <input v-model="ipp" class="input" type="text">
          <small v-if="errorIpp" class="text-danger"><br> Nous n'avons pas réussi à vous authentifier. S'il vous plaît vérifiez votre IPP.
            <br> Il vous reste {{ 4 - nbTrials }} essais.
          </small>
        </div>
        <button class="btn btn-primary" @click="validate()">
          Valider
        </button>
      </div>
      <div class="w-40 mt-5">
        <small>
          Vous pouvez retrouver votre numéro d'identification patient :
          <ul class="mt-1 ml-5">
            <li>sur vos comptes rendus d'examens</li>
            <li>sur vos comptes rendus d'hospitalisation</li>
            <li>sur vos documents de facturation : relevés, récapitulatifs et factures</li>
          </ul>
        </small>
      </div>
      <button class="btn btn-link-primary" @click="logout()">
        Ce n'est pas vous? Cliquez ici
      </button>
    </div>
  </div>
</template>

<script>
  import AuthService from "../../services/auth.service";
export default {
  name: 'Auth',
  data () {
      return {
        ipp: '',
        errorIpp: false,
        serverIsAuth: false,
        nbTrials: 0,
        isMagicToken: false
      };
  },

  computed: {
    user() {
      return AuthService.getUserInfos();
    },
  },

  watch:{
    serverIsAuth() {
      if(this.serverIsAuth) {
        if(this.isMagicToken) {
          sessionStorage.setItem("isMagicToken", true);
          this.$router.push({name: 'MagicPassword'});
        } else {
          this.$router.push({name: 'Profil'});     
        }
      } else {
        this.$router.push({name: '403'});
      }
    }
  },

  mounted(){
    this.isMagicToken = sessionStorage.getItem("isMagicToken");
  },

  methods: {
    logout() {
       AuthService.logout();
    },

    validate() {
      if(this.ipp) {
        this.loginClient();
      } else {
        this.invalidIPP();
      }
    },

    invalidIPP() {
      this.errorIpp = true;
      this.nbTrials += 1;
      if (this.nbTrials > 3) {
        this.$router.push({name: '403'});
      }
    },

    loginClient() {
        AuthService.authentication(this.ipp).then(
          response => {
            this.serverIsAuth = Boolean(response.access_token);
          }
        )
        .catch(() => {
            this.invalidIPP();
        });
    },

  }
};
</script>

<style>
.input {
  height: 40px;
  width: 20%;
}
</style>
